module.exports = __webpack_public_path__ + "img/logo-3.9a0c60da.png";